import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect, useParams } from 'react-router-dom';
import { SYSTEM_OVERVIEW_PATH, SYSTEM_PERFORMANCE_PATH, pathToRoute } from '../constants/routes';
import InfoHubRedirectBanner from '../components/InfoHubRedirectBanner';
import DeprecationWarningBanner from '../components/DeprecationWarningBanner';
import getInfoHubUrl from '../utils/get-infohub-url';
import SystemOverview from './SystemOverview';
import SystemPerformance from './SystemPerformance';

const SystemPage = ({ hideSystemContent, depWarnSystem }) => {
  const { prospectId } = useParams();
  const assetsUrl = getInfoHubUrl(`prospect/${prospectId}/assets?tab=infohub`);
  const performanceUrl = getInfoHubUrl(`prospect/${prospectId}/performance`);

  return (
    <Switch>
      <Route path={SYSTEM_OVERVIEW_PATH}>
        {hideSystemContent ? (
          <InfoHubRedirectBanner title="System" infohubUrl={assetsUrl} />
        ) : (
          <>
            {depWarnSystem && <DeprecationWarningBanner title="System" infohubUrl={assetsUrl} />}
            <SystemOverview />
          </>
        )}
      </Route>
      <Route path={SYSTEM_PERFORMANCE_PATH}>
        {hideSystemContent ? (
          <InfoHubRedirectBanner title="Performance" infohubUrl={performanceUrl} />
        ) : (
          <>
            {depWarnSystem && <DeprecationWarningBanner title="Performance" infohubUrl={performanceUrl} />}
            <SystemPerformance />
          </>
        )}
      </Route>
      <Redirect to={pathToRoute(SYSTEM_OVERVIEW_PATH, { prospectId })} />
    </Switch>
  );
};

SystemPage.propTypes = {
  hideSystemContent: PropTypes.bool,
  depWarnSystem: PropTypes.bool,
};

export default SystemPage;
